<template>
    <v-dialog
        v-model="$store.state.eleos.pending"
        fullscreen
        style="background: #fff"
    >
        <v-card>
            <v-toolbar dark color="secondary" dense class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title> Demurrages </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                    dark
                    icon
                    left
                    @click="$store.state.eleos.pending = false"
                    ><v-icon>mdi-close</v-icon></v-btn
                >
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-data-table
                    :headers="headers"
                    :items="pending"
                    hide-actions
                >
                <template v-slot:item.Description="{ item }">
                   <v-text-field
                    v-model="item.Description"
                    hide-details
                    dense
                    @change="saveComment(item)"
                    ></v-text-field>
                </template><template v-slot:item.Action="{ item }">
                    <v-icon small @click="saveDmr(item)" v-if="!item.Reload">mdi-content-save</v-icon>
                    <v-progress-circular
                        v-else
                        small
                        indeterminate
                        color="primary"
                    ></v-progress-circular>
                </template>
                </v-data-table>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from "axios";
    export default {
        props:['pending'],
        data: function(){
            return {
                headers:[
                    { text: 'Date', value: 'Date' },
                    { text: 'ShiftDetail', value: 'ShiftDetail' },
                    { text: 'Driver', value: 'Driver' },
                    { text: 'OrderID', value: 'OrderID' },
                    { text: 'TranType', value: 'TranType' },
                    { text: 'Time', value: 'Time' },
                    { text: 'Description', value: 'Description', width:'50%' },
                    { text: 'Action', value: 'Action' },
                ]
            }
        },
        methods:{
            saveDmr: async function(itm){
                     itm.Reload = true;
                     var parms = {
                         Pending: false,
                     }
                     axios
                     .put('demurrage-check/'+itm.DemurrageCheckID,parms,{
                         headers: {
                             Authorization: 'Bearer ' + this.$store.state.token
                         }
                     })
                     .then(response => {
                        console.log(response.data);
                        var idx = this.pending.findIndex(x => {
                            return x.DemurrageCheckID == itm.DemurrageCheckID;
                        });
                        this.pending.splice(idx, 1);
                        itm.Reload = false;
                     })
                     .catch(function (error) {
                        itm.Reload = true;
                         console.log(error);
                     });
            },
            saveComment: async function(itm){
                     var str = this.$store;
                     var parms = {
                        Description: itm.Description,
                     }
                     axios
                     .put('demurrage-check/'+itm.DemurrageCheckID,parms,{
                         headers: {
                             Authorization: 'Bearer ' + this.$store.state.token
                         }
                     })
                     .then(response => {
                        console.log(response.data);
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text:'Description Saved'
                        });
                     })
                     .catch(function (error) {
                        itm.Reload = true;
                         console.log(error);
                     });
            }
        },
        mounted(){

        }
    }

</script>